import { Collapse, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import './SignUp.css'
import { useDispatch } from 'react-redux'
import { setPassword } from 'redux/actions/'
import { useState } from 'react'
import usePasswordChecker from 'utils/usePasswordChecker'

export default function Login() {
  const dispatch = useDispatch()
  const [localPassword, setLocalPassword] = useState({
    password: '',
    confirm: ''
  })
  const {
    validPassword,
    error: warning,
    isMismatched,
    isEmpty
  } = usePasswordChecker(localPassword.password, localPassword.confirm)

  useEffect(() => {
    if (isEmpty) {
      dispatch(setPassword({ password: '', match: false }))
      return
    }
    dispatch(setPassword({ password: validPassword, match: !warning }))
  }, [
    localPassword.password,
    localPassword.confirm,
    validPassword,
    warning,
    isMismatched,
    isEmpty,
    dispatch
  ])

  const handlePassword = e => {
    setLocalPassword({ ...localPassword, [e.target.name]: e.target.value })
  }
  return (
    <>
      <Typography variant="h2" align="center" style={{ padding: '25px 0' }}>
        Please choose a password
      </Typography>
      <label>Password</label>
      <input
        placeholder="********"
        type="password"
        name="password"
        onChange={handlePassword}
      />
      <label>Confirm Password</label>
      <input
        placeholder="*********"
        type="password"
        name="confirm"
        onChange={handlePassword}
      />
      <Collapse in={!!warning}>
        <Typography className="warning-text" color="error" variant="caption">
          {warning}
        </Typography>
      </Collapse>
    </>
  )
}
